import DOMPurify from 'dompurify';
import './MaintenanceBanner.css';

/** Inline links use class `maintenance-banner-link`; sanitized below. */
const LIMITED_ACCESS_BANNER_HTML =
  'Your account access is currently limited. Please contact Customer Relations on <a href="tel:+443330124819" class="maintenance-banner-link">0333 012 4819</a> or email <a href="mailto:info@eori.uk" class="maintenance-banner-link">info@eori.uk</a>.';

const priorityHtmlSanitizeConfig = {
  ALLOWED_TAGS: ['a'],
  ALLOWED_ATTR: ['href', 'class'],
};

/**
 * Same visual strip as the global limited-access banner (maintenance-banner + inline links).
 */
export default function LimitedAccessBannerStrip({ className = '' }) {
  return (
    <div className={`maintenance-banner ${className}`.trim()} role="alert">
      <p
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(LIMITED_ACCESS_BANNER_HTML, priorityHtmlSanitizeConfig),
        }}
      />
    </div>
  );
}
